!function(){
  UC.views.AccountIdentityVerificationSsn = UC.views.AccountIdentityVerification = UC.views.AccountIdentityVerificationAddress = UC.views.AccountStripeTos = Backbone.View.extend({
    initialize: function(){
      new UC.partials.AccountIdentityVerification;
    }
  });
}();